module.exports = __webpack_public_path__ + "img/scatter_freespin.add0bd7d.png";